export default {
  state: {
    user: {},
    isAuthenticated: false
  },
  actions: {
    login({ commit }, data) {
      commit("setUser", data);
    },
    logout({ commit }) {
      commit("logout");
    }
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.user = {};
      state.isAuthenticated = false;
    }
  }
};
